import { render } from "./StaffReports.vue?vue&type=template&id=5ff09ddb&scoped=true"
import script from "./StaffReports.vue?vue&type=script&lang=js"
export * from "./StaffReports.vue?vue&type=script&lang=js"

import "./StaffReports.vue?vue&type=style&index=0&id=5ff09ddb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff09ddb"]])

export default __exports__